import client from "../libs/HttpClient";

class ManualServices {
  static manualList(request) {
    
    const page_no = request.queryKey[1];
    return client.get(`/manual?page=${page_no}`, request);
  }
  static addManual(request) {
    return client.post(`/add-manual`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateManual(request) {
    return client.post(`/edit-manual`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewManual(params) {
    return client.get(`/get-manual`, { params });
  }
  static deleteManual(params) {
    return client.delete(`/delete-manual`, { params });
  }
  static deleteManualPdfIT(params) {
    return client.delete(`/delete-pdf-it-manual`, { params });
  }
  static deleteManualPdfDE(params) {
    return client.delete(`/delete-pdf-de-manual`, { params });
  }
}

export { ManualServices };
